// extracted by mini-css-extract-plugin
export default {"900":"(min-width: 900px)","root":"jcpGYWF9PrW4wVRgJevf","item":"FmnEKHXpVDg9o9AXPPSA","link":"q1dTHGEy90xZBBHqDA96","active":"aVqbd5ncMuZL1GS5mwH5"};